import { useCallback } from 'react'

import LeadService from 'modules/lead/service/service'
import { useLeadContext } from 'modules/lead/context'

const useSetLeadAsWatched = () => {
  const { lead: { schedule, accepted, email, name } } = useLeadContext()

  const setLeadAsWatched = useCallback(async (contactId: string) => {
    if (!schedule || !contactId) {
      return
    }

    await LeadService.postLead({
      contactId,
      schedule,
      accept: Boolean(accepted),
      email,
      name
    })
  }, [schedule, accepted, email, name])

  return setLeadAsWatched
}

export default useSetLeadAsWatched
